import * as actions from "./actionTypes";

const initialState = {
  isOpen: false,
  showFilter: false,
  filter: {
    date: [new Date(new Date() - 24 * 60 * 60 * 1000), new Date()],
  },
  pagination: {
    current: 1,
    pageSize: 10,
    total: 0,
  },
  sort: {
    path: "status",
    order: "asc",
  },
  forms: {
    skills: [],
    agents: [],
  },
  tableData: [],
  status: {
    table: {
      loading: false,
      error: null,
      success: false,
      message: null,
    },
    forms: {
      loading: false,
      error: null,
      success: false,
    },
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.HANDLE_TICKET_AREA:
      return {
        ...state,
        isOpen: action.payload.isOpen,
        showFilter: action.payload.isOpen ? state.showFilter : false,
      };
    case actions.HANDLE_FILTER_AREA:
      return {
        ...state,
        showFilter: !state.showFilter,
      };
    case actions.GET_TICKET_LIST:
      return {
        ...state,
        status: {
          ...state.status,
          table: {
            loading: true,
            error: null,
            success: false,
            message: null,
          },
        },
      };
    case actions.GET_TICKET_LIST_SUCCESS:
      return {
        ...state,
        showFilter: !action.payload.total > 0,
        tableData: action.payload.total > 0 ? action.payload.data : state.tableData,
        pagination: {
          ...state.pagination,
          total: action.payload.total > 0 ? action.payload.total : state.pagination.total,
        },
        status: {
          ...state.status,
          table: {
            loading: false,
            error: null,
            success: true,
            message: !action.payload.total && "No tickets found",
          },
        },
      };
    case actions.GET_TICKET_LIST_ERROR:
      return {
        ...state,
        status: {
          ...state.status,
          table: {
            loading: false,
            error: action.payload.error,
            success: false,
          },
        },
      };
    case actions.GET_TICKET_FORMS:
      return {
        ...state,
        status: {
          ...state.status,
          forms: {
            loading: true,
            error: null,
            success: false,
          },
        },
      };
    case actions.GET_TICKET_FORMS_SUCCESS:
      return {
        ...state,
        forms: {
          skills: action.payload.skills,
          agents: action.payload.agents,
        },
        status: {
          ...state.status,
          forms: {
            loading: false,
            error: null,
            success: true,
          },
        },
      };
    case actions.GET_TICKET_FORMS_ERROR:
      return {
        ...state,
        status: {
          ...state.status,
          forms: {
            loading: false,
            error: action.payload.error,
            success: false,
          },
        },
      };
    case actions.SET_TICKET_FILTER:
      return {
        ...state,
        filter: action.payload.filter,
        pagination: {
          ...state.pagination,
          current: 1,
        },
        status: {
          ...state.status,
          table: {
            loading: true,
            error: null,
            success: false,
          },
        },
      };
    case actions.RESET_TICKET_FILTER:
      return {
        ...state,
        filter: {},
      };
    case actions.NEXT_TICKET_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          current: state.pagination.current + 1,
        },
        status: {
          ...state.status,
          table: {
            loading: true,
            error: null,
            success: false,
          },
        },
      };

    case actions.PREV_TICKET_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          current: state.pagination.current - 1,
        },
        status: {
          ...state.status,
          table: {
            loading: true,
            error: null,
            success: false,
          },
        },
      };

    case actions.SET_TICKET_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          current: action.payload.page,
        },
      };

    case actions.SET_TICKET_SORT:
      return {
        ...state,
        sort: action.payload.sort,
        pagination: {
          ...state.pagination,
          current: 1,
        },
        status: {
          ...state.status,
          table: {
            loading: true,
            error: null,
            success: false,
          },
        },
      };

    default:
      return state;
  }
};

export default reducer;
